import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/Login.vue";
import Contact from "@/views/Contact.vue";
import AdminUsers from "@/views/admin/Users.vue";
import AdminProjects from "@/views/admin/Projects.vue";
import ProjectHome from "@/views/projects/_id/Home.vue";
import Project_id from "@/views/projects/_id/Index.vue";
import ProjectsOverview from "@/views/projects/Overview.vue";
import HdrViewer from "@/views/projects/_id/HdrViewer.vue";
import DamageTable from "@/views/projects/_id/DamageTable.vue";
import BimViewer from "@/views/projects/_id/BimViewer.vue";
import GisWeb from "@/views/projects/_id/GisWeb.vue";
import Viewer3d from "@/views/projects/_id/Viewer3d.vue";
import NotFound404 from "@/views/NotFound404.vue";
import HelpAdmin from "@/views/help/admin.vue"

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      meta: { auth: false },
      component: Login
    },
    {
      path: "/",
      meta: { auth: true },
      redirect: "/projekte/uebersicht"
    },
    {
      path: "/admin/benutzer",
      meta: { auth: true },
      component: AdminUsers
    },
    {
      path: "/kontakt",
      meta: { auth: true },
      component: Contact
    },
    {
      path: "/admin/projekte",
      meta: { auth: true },
      component: AdminProjects
    },
    {
      path: "/projekte",
      meta: { auth: true },
      redirect: "/projekte/uebersicht"
    },
    {
      path: "/projekte/uebersicht",
      meta: { auth: true },
      component: ProjectsOverview
    },
    {
      path: "/projekte/:projectRouteName",
      meta: { auth: true },
      component: Project_id,
      // redirect: "/projekte/:id/start",
      children: [
        {
          path: "start",
          component: ProjectHome
        },
        {
          path: "life-viewer",
          component: DamageTable
        },
        {
          path: "hdr-viewer/:perspectiveRouteName",
          component: HdrViewer
        },
        {
          path: "3d-viewer/:perspectiveRouteName",
          component: Viewer3d
        },
        {
          path: "web-gis/:perspectiveRouteName",
          component: GisWeb
        },
        {
          path: "bim-viewer",
          component: BimViewer
        }
      ]
    },
    {
      path: "/hilfe/admin",
      meta: { auth: true },
      component: HelpAdmin,
    },
    { path: "*", component: NotFound404 }
  ]
});

Vue.router = router;

export default router;
